import React, { useEffect, useState } from "react";
import moment from "moment";
import {
  AESEncryption,
  ApiResDecrypt,
  checkDateRange,
  compareDate,
  decryptData,
  encryptData,
  noDataFound,
} from "../../../CommonMethhods/CommonMethods";
import { Dashboard_Client_Report } from "../../../Configuration/API_URL";
import SmallLoader from "../../../Components/Common/smallLoader";
import { Constants, DP_TYPE_OPTIONS } from "../../../CommonMethhods/Constants";
import DpReportTable from "../../../Components/ReportTables/DpReportTable";
import Loader from "../../../Components/Common/Loader";
import FromdateComponent from "../../Reports/FromdateComponent";
import TodateComponent from "../../Reports/TodateComponent";
import { toast } from "react-toastify";
import { Partner_Reports } from "../../../Configuration/Partner_URL";
import DurationChangeComponent from "../../Reports/DurationChangeComponent";
import axiosInstance from "../../../CommonMethhods/axiosInstance";

function DPReportNew(props) {
  const storeToken = localStorage.getItem("ssoToken");
  const partnerSsoToken = localStorage.getItem("partnerSsoToken");
  const partnerRoleNew = localStorage.getItem("partnerRoleNew");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [gridVal, setGridVal] = useState("");
  const [loader, setLoader] = useState(false);
  const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
  const [smallLoaderPdf, setSmallLoaderPdf] = useState(false);
  const [error, setError] = useState(false);
  const [smallLoaderMail, setSmallLoaderMail] = useState(false);
  const [selection, setSelection] = useState("bill-tran");
  const [flag, setFlag] = useState("tran");
  const [noReportFound, setNoReportFound] = useState(false);
  const [customShow, setCustomShow] = useState(false)
  const ClientId2 = localStorage.getItem("ClientId2");
  const [depository, setDepository] = useState("cdsl");


  if (fromDate === "" || toDate === "") {
    // const current = new Date();
    // const CurrentYear = current.getFullYear();
    // const CurrentMonth = current.getMonth();
    // if (CurrentMonth < 4) {
    //   const newYear = `04-01-${CurrentYear - 1}`;
    //   const date = `${current.getMonth() + 1
    //     }-${current.getDate()}-${current.getFullYear()}`;
    //   const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
    //   setFromDate(newYear);
    //   setToDate(date1);
    // } else {
    //   const newYear = `04-01-${CurrentYear}`;
    //   const date = `${current.getMonth() + 1
    //     }-${current.getDate()}-${current.getFullYear()}`;
    //   const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
    //   setFromDate(newYear);
    //   setToDate(date1);
    // }
    let date = new Date();
        let firstDay = "";
        let lastDay = "";
        let firstVal = new Date(date.getFullYear(), date.getMonth(), 1);
        firstDay = moment(firstVal, "MM-DD-YYYY").format("MM-DD-YYYY");
        let lastVal = new Date();
        lastDay = moment(lastVal, "MM-DD-YYYY").format("MM-DD-YYYY");
        setFromDate(firstDay)
        setToDate(lastDay)
  }
  let clientCode = "";

  const getDPReport = async (fileView, mainLoader = false, clientCode) => {
    setSmallLoaderExcel(fileView === "excel");
    setSmallLoaderPdf(fileView === "pdf");
    setSmallLoaderMail(fileView === "mail");
    setLoader(mainLoader && fileView === "grid");
    let payloadValue = {
      clientCode: clientCode || ClientId2,
      fromDate: fromDate,
      toDate: toDate,
      fileType: fileView,
      seg: "stocks",
      flag: selection === "trade" ? "trans" : flag,
      selection: selection,
      dpType: depository
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getDetails = await axiosInstance.post(
        Dashboard_Client_Report.DPReport_URL,
        `"${encPayload}"`,
      );
      const res = ApiResDecrypt(getDetails?.data);

      if (res?.status === 0) {
        setNoReportFound(false);
        if (fileView === "grid") {
          if (selection === "bill-tran") {
            if (flag === "tran") {
              setGridVal(res.data?.dpT);
            } else {
              setGridVal(res.data?.DpBill);
            }
          } else {
            setGridVal(res?.data?.DpList);
          }
        }
        if (fileView === "excel") {
          window.open(res?.data, "_self", "noopener,noreferrer");
        }
        if (fileView === "pdf") {
          window.open(res?.data, "_blank", "noopener,noreferrer");
        }
        if (fileView === "mail") {
          toast.success("Mail sent successfully");
        }
      } else {
        if (fileView !== "grid") {
          toast.error(res?.message);
        } else {
          setGridVal([]);
          setNoReportFound(res?.message);
        }
      }
    } catch (error) {
      console.log(error);
      setNoReportFound(error?.message);
      if (fileView !== "grid") {
        toast.error(error?.message);
      } else {
        setGridVal([]);
      }
    } finally {
      setLoader(false);
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
      setSmallLoaderMail(false);
    }
  };
  function formatDate(date) {
    return moment(date, "MM-DD-YYYY").format("YYYY-MM-DD");
  }

  const handleFromDateChange = (e) => {
    let c = e.target.value;
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setFromDate(d);
    setError(false);
    setGridVal([]);
  };
  const handleToDateChange = (e) => {
    let c = e.target.value;
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setToDate(d);
    setError(false);
    setGridVal([]);
  };
  useEffect(() => {
    if (localStorage.getItem("clientCode") || ClientId2) {
      clientCode = localStorage.getItem("clientCode");

      if (
        compareDate(fromDate) &&
        compareDate(toDate) &&
        checkDateRange(fromDate, toDate)
      ) {
        getDPReport("grid", true, clientCode);
        setNoReportFound(false);
      } else {
        setGridVal(false);
      }
    }
  }, []);

  const handleSelectionChange = (e) => {
    setGridVal([]);
    setNoReportFound(false);
    setSelection(e.target.value);
    setLoader(false);
  };

  const handleFlagOnChange = (e) => {
    setNoReportFound(false);
    setLoader(false);
    setGridVal([]);
    if (e.target.value) {
      setFlag(e.target.value);
    }
  };

  const handleDepositoryChange = e => {
    setGridVal([]);
    setNoReportFound(false);
    setLoader(false);
    setDepository(e.target.value);
  }

  const handleOnClick = (e) => {
    if (localStorage.getItem("clientCode") || ClientId2) {
      clientCode = localStorage.getItem("clientCode");
      if (e.target.value) {
        if (
          compareDate(fromDate) &&
          compareDate(toDate) &&
          checkDateRange(fromDate, toDate)
        ) {
          getDPReport(e.target.value, true, clientCode);
          setNoReportFound(false);
        } else {
          setError("Please Select Correct Date");
        }
      }
    }
  };

  const currentDate = new Date();
  const yyyy = currentDate.getFullYear();
  let mm = currentDate.getMonth() + 1;
  let dd = currentDate.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  const FormatedDate = dd + "/" + mm + "/" + yyyy;
  const DateReverse = FormatedDate.split("/").reverse().join("-");

  const onChangeDuration=()=>{
    setError(false);
    setGridVal([]);
  }

  return (
    <>
      <div
        className="tab-pane fade show active"
        id="dp-report"
        role="tabpanel"
        aria-labelledby="dp-report"
      >
        <div style={{columnGap: "2rem", flexDirection: customShow ? "column" : "row", alignItems: customShow ? "flex-start" : "center"}} className="reports-date-filter">
          <div style={{flexGrow: 1}} className="reports-left-form d-flex w-100">
            <form style={{display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(160px,1fr))", width: "100%"}}>
              {/* <div style={{display: "grid"}} className="report-form-wrapper"> */}
                <div className="form-group">
                  <DurationChangeComponent
                    setCustomShow={setCustomShow}
                    setFromDate={setFromDate}
                    setToDate={setToDate}
                    onChangeDuration={onChangeDuration}
                    className="report-custom-select w-100"
                    screen="Client Dashboard"
                  />
                </div>
                {customShow && <>
                  <FromdateComponent
                    fromDate={handleFromDateChange}
                    formatDate={formatDate(fromDate)}
                    DateReverse={DateReverse}
                  />

                  <TodateComponent
                    toDate={handleToDateChange}
                    formatToDate={formatDate(toDate)}
                    DateReverse={DateReverse}
                    errorResponse={error}
                  />
                </>}
              {/* </div> */}
              <div className="form-group">
                <label className="form-label">Selection:</label>
                <select
                  className="report-custom-select w-100"
                  onChange={handleSelectionChange}
                  style={{ padding: "5px" }}
                >
                  <option value="bill-tran">Bill Transaction</option>
                  <option value="trade">Trade</option>
                </select>
              </div>

              {selection === "bill-tran" && (
                <div className="form-group">
                  <label className="form-label">Flag:</label>
                  <select
                    className="report-custom-select w-100"
                    onChange={handleFlagOnChange}
                  >
                    <option value="tran">Tran</option>
                    <option value="bill">Bill</option>
                  </select>
                </div>
              )}

              <div className="form-group">
                <label className="form-label">DP Type:</label>
                <select className="report-custom-select w-100" onChange={handleDepositoryChange}>
                  {DP_TYPE_OPTIONS.map((opt) => {
                    return (
                      <option key={opt.value} value={opt.value}>
                        {opt.label}
                      </option>
                    );
                  })}
                </select>
              </div>

              <div  style={{justifySelf: "start"}}>
                <button 
                  className="generate-button get-data"
                  type="button"
                  value="grid"
                  onClick={handleOnClick}
                  >
                  {Constants.Submit}
                </button>
              </div>
            </form>
          </div>
         
          <div className="report-btn-wrapper">
            <button
              className="generate-button mail-btn"
              value="mail"
              onClick={handleOnClick}
            >
              {smallLoaderMail ? (
                // <div>
                <SmallLoader />
              ) : (
                <>
                  <span className="icon-email"></span>
                  E-Mail
                </>
              )}
            </button>

            <button
              className="generate-button excel-btn"
              value="excel"
              onClick={handleOnClick}
            >
              {smallLoaderExcel ? (
                <div>
                  <SmallLoader />
                </div>
              ) : (
                <>
                  <span className="icon-excelsvg"></span>
                  {Constants.Excel}
                </>
              )}
            </button>
            <button
              className="generate-button pdf-btn"
              value="pdf"
              onClick={handleOnClick}
            >
              {smallLoaderPdf ? (
                <div>
                  <SmallLoader />
                </div>
              ) : (
                <>
                  <span className="icon-pdfsvg"></span>
                  {Constants.PDF}
                </>
              )}
            </button>
          </div>
        </div>
      </div>

      {loader ? (
        <div className="loader-alignment">
          <Loader />
        </div>
      ) : (
        gridVal &&
        gridVal.length > 0 && (
          <div>
            <DpReportTable
              gridVal={gridVal}
              selection={selection}
              flag={flag}
            />
          </div>
        )
      )}
      {noReportFound && (
        <h4 className="report-error-message">{noDataFound(noReportFound, {position: "static"})}</h4>
      )}
    </>
  );
}
export default DPReportNew;
